import { render } from "./BannerArtwork.vue?vue&type=template&id=8eb5acda&scoped=true&ts=true"
import script from "./BannerArtwork.vue?vue&type=script&lang=ts"
export * from "./BannerArtwork.vue?vue&type=script&lang=ts"

import "./BannerArtwork.vue?vue&type=style&index=0&id=8eb5acda&scoped=true&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eb5acda"]])

export default __exports__